<!-- src/app/pages/dashboard/profile/transactions-sheet/transactions-sheet.component.html -->
<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-title>
      <div class="flex flex-col">
        <span class="text-lg font-bold text-surface-900 dark:text-surface-50">Transaktionen</span>
        <span class="text-xs text-surface-600 dark:text-surface-400 mt-0.5">
          {{ total }} {{ total === 1 ? 'Transaktion' : 'Transaktionen' }}
        </span>
      </div>
    </ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="close()">
        <ion-icon slot="icon-only" name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="transactions-sheet-content">
  <!-- Loading State -->
  <div *ngIf="isLoading && transactions.length === 0" class="p-4 space-y-2">
    <div *ngFor="let i of [1,2,3,4,5,6,7,8]" class="flex items-center gap-3 px-4 py-3">
      <ion-skeleton-text animated style="width: 36px; height: 36px; border-radius: 50%;"></ion-skeleton-text>
      <div class="flex-1">
        <ion-skeleton-text animated style="width: 65%; height: 14px; margin-bottom: 6px;"></ion-skeleton-text>
        <ion-skeleton-text animated style="width: 45%; height: 12px;"></ion-skeleton-text>
      </div>
      <ion-skeleton-text animated style="width: 60px; height: 16px;"></ion-skeleton-text>
    </div>
  </div>

  <!-- Transactions List -->
  <div *ngIf="!isLoading || transactions.length > 0">
    <div
      *ngFor="let transaction of transactions"
      class="flex items-center gap-3 px-4 py-3 border-b border-surface-100 dark:border-surface-800 hover:bg-surface-50 dark:hover:bg-surface-900 transition-colors active:bg-surface-100 dark:active:bg-surface-800"
      [class.cursor-pointer]="transaction.businessHubId"
      (click)="transaction.businessHubId ? viewBusiness(transaction) : null">
      
      <!-- Icon/Avatar -->
      <div
        class="w-9 h-9 rounded-full flex items-center justify-center flex-shrink-0"
        [ngClass]="{
          'bg-green-100 dark:bg-green-900/30': transaction.type === 'verdient',
          'bg-red-100 dark:bg-red-900/30': transaction.type === 'ausgegeben'
        }">
        <!-- Business Avatar -->
        <img
          *ngIf="transaction.businessAvatar && !imageErrors[transaction.id]"
          [src]="transaction.businessAvatar"
          [alt]="transaction.businessName"
          class="w-full h-full rounded-full object-cover"
          (error)="onImageError($event, transaction.id)">
        <!-- Fallback Icon -->
        <i
          *ngIf="!transaction.businessAvatar || imageErrors[transaction.id]"
          [class]="'pi ' + transaction.icon + ' ' + transaction.color + ' text-sm'"></i>
      </div>

      <!-- Transaction Details -->
      <div class="flex-1 min-w-0">
        <p class="text-sm font-medium text-surface-900 dark:text-surface-50 truncate mb-0.5">
          {{ transaction.description }}
        </p>
        <div class="flex items-center gap-2 flex-wrap">
          <p class="text-xs text-surface-500 dark:text-surface-400">
            {{ formatTimestamp(transaction.date) }}
          </p>
          
          <!-- Invoice Link -->
       
          
          <!-- Category Badge -->
          <span
            class="text-[10px] px-1.5 py-0.5 rounded-full bg-surface-100 dark:bg-surface-800 text-surface-600 dark:text-surface-400">
            {{ getCategoryLabel(transaction.category) }}
          </span>
        </div>
      </div>

      <!-- Amount -->
      <div class="text-right flex-shrink-0">
        <p
          class="text-sm font-bold"
          [ngClass]="{
            'text-green-600 dark:text-green-400': transaction.type === 'verdient',
            'text-red-600 dark:text-red-400': transaction.type === 'ausgegeben'
          }">
          {{ transaction.type === 'verdient' ? '+' : '-' }}{{ transaction.amount }}
        </p>
        <p class="text-[10px] text-surface-500 dark:text-surface-400">SC</p>
      </div>
    </div>

    <!-- Loading More State -->
    <div *ngIf="isLoading && transactions.length > 0" class="p-2">
      <div *ngFor="let i of [1,2,3]" class="flex items-center gap-3 px-4 py-3">
        <ion-skeleton-text animated style="width: 36px; height: 36px; border-radius: 50%;"></ion-skeleton-text>
        <div class="flex-1">
          <ion-skeleton-text animated style="width: 65%; height: 14px; margin-bottom: 6px;"></ion-skeleton-text>
          <ion-skeleton-text animated style="width: 45%; height: 12px;"></ion-skeleton-text>
        </div>
        <ion-skeleton-text animated style="width: 60px; height: 16px;"></ion-skeleton-text>
      </div>
    </div>
  </div>

  <!-- Empty State -->
  <div
    *ngIf="!isLoading && transactions.length === 0"
    class="flex flex-col items-center justify-center py-16 px-8">
    <div class="w-16 h-16 mb-4 rounded-full bg-surface-100 dark:bg-surface-800 flex items-center justify-center">
      <i class="pi pi-inbox text-3xl text-surface-400"></i>
    </div>
    <h3 class="text-base font-semibold text-surface-900 dark:text-surface-50 mb-1">
      Noch keine Transaktionen
    </h3>
    <p class="text-sm text-surface-600 dark:text-surface-400 text-center">
      Deine Transaktionshistorie wird hier angezeigt
    </p>
  </div>

  <!-- Load More Button -->
  <div *ngIf="hasMore && transactions.length > 0 && !isLoading" class="p-4 border-t border-surface-200 dark:border-surface-700">
    <ion-button expand="block" fill="outline" (click)="loadMore()">
      <ion-icon slot="start" name="chevron-down-outline"></ion-icon>
      Mehr laden
    </ion-button>
  </div>

  <!-- End of List -->
  <div
    *ngIf="!hasMore && transactions.length > 0"
    class="py-4 text-center border-t border-surface-200 dark:border-surface-700">
    <p class="text-xs text-surface-500 dark:text-surface-400">
      Alle Transaktionen geladen
    </p>
  </div>
</ion-content>